var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{on:{"click":function($event){return _vm.$refs.fileInput.click()}}},[_vm._t("content")],2),_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"change":_vm.onFileChange}})])}
var staticRenderFns = []

export { render, staticRenderFns }